<div class="{{ userDeviceInfo }}">
  @if (header === 'AUTHORIZED') {
    <header
      #headerRef
      (mousewheel)="defaultSearch = false; searchLabelRef && searchLabelRef.classList.remove('active')"
      (mouseenter)="myCart.cartLayer = false"
      (mouseleave)="defaultSearch = false"
    >
      @if (isNotChrome) {
        <app-unsupported-browser></app-unsupported-browser>
      }
      <div class="header-top" #authorizedHeaderTop>
        <div class="inner">
          <h1>
            <a [routerLink]="['/home']">
              <!-- <a [routerLink]="['/my']"> -->
              <img src="/assets/images/pc/logo_umma_small.svg" alt="umma" />
            </a>
          </h1>
          <!-- <div class="download-excel" *ngIf="user.email.indexOf('@b2link.co.kr') > 0">
          <button type="button" (click)="downloadExcel()">
            <img src="/assets/images/download.svg" />
            Inventory Excel
          </button>
        </div> -->
          <div class="search-box">
            <form [formGroup]="searchForm" (ngSubmit)="onSearch()">
              <fieldset>
                <label
                  #searchLabelRef
                  [class.active]="
                    !headerRef.classList.contains('active') && searchLabelRef.classList.contains('active')
                  "
                >
                  <input
                    formControlName="keyword"
                    #Keyword
                    type="search"
                    placeholder="{{ 'TERM.SEARCH' | t }}"
                    (click)="openDefaultSearch(); searchForm.get('keyword').setValue('')"
                    (keypress)="openDefaultSearch()"
                  />
                </label>
                <a class="search-link" (click)="onSearch(headerRef, searchLabelRef)"></a>
              </fieldset>
            </form>
            <!-- [class.active]="searchLabelRef.classList.contains('active')" -->
            @if (defaultSearch) {
              <div class="search-list" #searchList>
                <div class="search-focus">
                  <ul class="brand">
                    @for (brand of brandsType | slice: 0 : 3; track brand) {
                      <li>
                        <span [innerHtml]="'TITLE.BRAND_WITH_ANCHOR' | t">{{ brand.searchType }}</span>
                        <a
                          (click)="onClickKeyword(SEARCH_TYPE.BRAND, brand.item.id)"
                          [innerHTML]="brand.item.englishName | highlight: searchForm.get('keyword').value"
                          >{{ brand.item.englishName }}</a
                        >
                      </li>
                    }
                  </ul>
                  <ul>
                    @for (product of productType | slice: 0 : 10; track product; let i = $index) {
                      <li
                        class="ga-ee-product-impression"
                      >
                        <a
                          (click)="onClickKeyword(SEARCH_TYPE.PRODUCT, product.item.id)"
                          [innerHTML]="product.item.englishName | highlight: searchForm.get('keyword').value"
                          >{{ product.item.englishName }}</a
                        >
                      </li>
                    }
                  </ul>
                </div>
                @if (isSearching && !(brandsType && brandsType.length) && !(productType && productType.length)) {
                  <div class="keyword-no">
                    <ul>
                      <li class="nodata">
                        <p [innerHTML]="'SEARCH.NO_RESULT' | t">There are no related keyword.<br />Try again.</p>
                        @if (searchForm.get('keyword').value.length >= 5) {
                          <a [innerHTML]="'BUTTON.REQUEST_SUPPLY' | t" (click)="inquiry.open()"> 입고요청</a>
                        }
                      </li>
                    </ul>
                  </div>
                }
                @if (!isSearching || !searchForm.get('keyword').value) {
                  <div class="search-detail">
                    <div class="recent">
                      <p class="tit" [innerHTML]="'SEARCH.RECENT' | t">Recent</p>
                      <a class="clear" (click)="clearAllItems()" [innerHTML]="'BUTTON.CLEAR_ALL' | t">Clear All</a>
                      <ul>
                        <li class="nodata" [style.display]="recentSearches.length ? 'none' : 'block'">
                          <p [innerHTML]="'SEARCH.NOTHING' | t">
                            There are no recent searches.<br />Search for a Product.
                          </p>
                        </li>
                        @if (recentSearches.length) {
                          @for (search of recentSearches; track search; let i = $index) {
                            <li>
                              <a (click)="onClickKeyword(SEARCH_TYPE.SEARCH, search, false)">{{ search }}</a>
                              <button (click)="onRemoveItems($event, i)">
                                <img src="/assets/images/pc/icon-delete-serch-result.svg" />
                              </button>
                            </li>
                          }
                        }
                      </ul>
                    </div>
                    <div class="trend">
                      <p class="tit trend" [innerHTML]="'SEARCH.TREND' | t">Trend</p>
                      <ul>
                        @for (search of popularSearches; track search) {
                          <li>
                            <a (click)="onClickKeyword(SEARCH_TYPE.SEARCH, search.keyword, true)">{{
                              search.keyword
                            }}</a>
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <div class="right-area">
            <a class="account_more" [routerLink]="['/my']">
              <span class="icon"> </span>
              <dl>
                <dt [innerHTML]="'TERM.NAVIGATION.MY' | t">My Account</dt>
                <dd>
                  <span class="underline-action"> Hi, {{ user.firstName }} </span>
                </dd>
              </dl>
            </a>
            <app-my-cart #myCart class="cart_more"></app-my-cart>
            <!-- <div class="language_more">
                <div #language class="option-select languages">
                  <div class="language" (click)="language.classList.toggle('active')">
                    <img src="/assets/images/{{ googleLanguage.locale }}.svg" />
                    {{ googleLanguage.label }}
                    <i class="icon-toggle-arrow">
                      <span class="icon-toggle-arrow__i"> </span>
                    </i>
                  </div>
                  <div class="options">
                    <div [class.selected]="googleLanguage.locale === language.locale"
                      (click)="onChangeGoogleLanguage(language.locale)" *ngFor="let language of GOOGLE_LANGUAGES">
                      <img src="/assets/images/{{ language.locale }}.svg" /> {{ language.label }}
                    </div>
                  </div>
                </div>
              </div> -->
          </div>
        </div>
      </div>
      <div class="gnb" (mouseenter)="defaultSearch = false; myCart.cartLayer = false">
        <div class="inner">
          <div class="gnb-link">
            <ul>
              @for (category of displayCategory; track category) {
                <li #depth1>
                  <a (click)="goCategory(category?.id)"
                    >{{ category?.code | categoryCode }}
                    <i class="icon-toggle-arrow">
                      <span class="icon-toggle-arrow__i"> </span>
                    </i>
                  </a>
                </li>
              }
            </ul>
            <span class="gnb-second" [class.hidden]="searchLabelRef.classList.contains('active')">
              <a class="color best" [routerLink]="['/brand']">
                <!-- <a class="color best"> -->
                <span class="underline-action pink" [innerHTML]="'TERM.NAVIGATION.BRAND' | t"> Brand </span>
              </a>
              <a class="color" [routerLink]="['/u-quick']">
                <span class="underline-action pink">
                  <span class="link__tab-text">U-Quick</span>
                </span>
              </a>
              <a class="color" [routerLink]="['/u-outlet']">
                <span class="underline-action pink">
                  <span class="link__tab-text">U-Outlet</span>
                </span>
              </a>
              <a class="color" [routerLink]="['/promotion-notice']">
                <span class="underline-action pink">
                  <span class="link__tab-text">Offers</span>
                </span>
              </a>
              <a class="color" [routerLink]="['/under-ten']">
                <span class="underline-action pink">
                  <span class="link__tab-text"
                    >Under $10
                    @if (!uDirectService.isUDirect) {
                      <span class="icon_new">NEW</span>
                    }
                  </span>
                </span>
              </a>
              @if (uDirectService.isUDirect) {
                <a class="color" [routerLink]="[uDirectService.getUDirectPath()]">
                  <span class="underline-action pink">
                    <span class="link__tab-text"
                      >{{ uDirectService.uDirectZone }} Direct<span class="icon_new">NEW</span></span
                    >
                  </span>
                </a>
              }
            </span>
          </div>
          <div class="right-area">
            <a class="guide" target="_blank" [routerLink]="['/beginner-guide']">
              <!-- <a class="guide" target="_blank"> -->
              <span class="underline-action"> Beginner's Guide > </span>
            </a>
          </div>
        </div>
        <div class="group-snb" #snbCategory>
          @for (depth of displayCategoryTree.children; track depth; let i = $index) {
            <div class="group-snb-list">
              <ul class="sub-list">
                @for (depth2 of depth.children; track depth2) {
                  <li>
                    <p class="sub-txt">{{ depth2.item.name }}</p>
                    <ul>
                      <li>
                        <a (click)="goCategory(depth2.item.id)"
                          ><span class="underline-action" [innerHTML]="'TERM.ALL' | t">All</span></a
                        >
                      </li>
                      @for (depth3 of depth2.children; track depth3) {
                        <li>
                          <a (click)="goCategory(depth3.item.id)"
                            ><span class="underline-action">{{ depth3.item.name }}</span></a
                          >
                        </li>
                      }
                    </ul>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
      @if (noticeBoards.length !== 0) {
        <div class="swiper-container visualNoticeConfig">
          @if (noticeBoards.length > 1) {
            <div class="notice-button-box">
              <img
                src="/assets/images/chevron-back-outline.svg"
                class="button-prev-notice"
                alt=""
                (click)="$event.stopPropagation()"
              />
              <img
                src="/assets/images/chevron-forward-outline.svg"
                class="button-next-notice"
                alt=""
                (click)="$event.stopPropagation()"
              />
            </div>
          }
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper">
            <!-- Slides -->
            @for (noticeBoard of noticeBoards; track noticeBoard; let i = $index) {
              <div class="swiper-slide top-notice">
                <div class="inner">
                  <p>
                    <a (click)="goPage('/my/notice/' + noticeBoard.id, i)">
                      {{ noticeBoard.subject }}
                    </a>
                  </p>
                </div>
              </div>
            }
          </div>
        </div>
      }
    </header>
  }

  @if (header === 'UNAUTHORIZED') {
    <header class="simple" [ngClass]="{ 'unsupported-browser': isNotChrome }">
      @if (isNotChrome) {
        <app-unsupported-browser></app-unsupported-browser>
      }
      <div class="gnb">
        <div class="inner">
          <a class="home-link" (click)="goMain()">
            <img src="../../../../assets/images/logo_umma_small.svg" alt="logo" />
          </a>
          <!-- <div #language class="option-select languages">
                    <div class="language" (click)="language.classList.toggle('active')">
                      <img src="/assets/images/{{ googleLanguage.locale }}.svg" />
                      {{ googleLanguage.label }}
                      <i class="icon-toggle-arrow">
                        <span class="icon-toggle-arrow__i"> </span>
                      </i>
                    </div>
                    <div class="options">
                      <div [class.selected]="googleLanguage.locale === language.locale"
                        (click)="onChangeGoogleLanguage(language.locale)" *ngFor="let language of GOOGLE_LANGUAGES">
                        <img src="/assets/images/{{ language.locale }}.svg" /> {{ language.label }}
                      </div>
                    </div>
                  </div> -->
          <!-- <div #language class="option-select languages">
                  <div class="language" (click)="language.classList.toggle('active')">
                    <img src="/assets/images/{{ lang.locale }}.svg" /> {{ lang.label | t }}
                    <i class="icon-toggle-arrow">
                      <span class="icon-toggle-arrow__i"> </span>
                    </i>
                  </div>
                  <div class="options">
                    <div
                      [class.selected]="lang.locale === language.locale"
                      (click)="onChangeLanguage(language.locale)"
                      *ngFor="let language of LANGUAGES"
                      >
                      <img src="/assets/images/{{ language.locale }}.svg" />{{ language.label | t }}
                    </div>
                  </div>
                </div> -->
        </div>
      </div>
    </header>
  }
  <div class="dim"></div>
  <div id="continer">
    <app-select-product></app-select-product>
    <app-select-bulk-product></app-select-bulk-product>
    <router-outlet></router-outlet>
  </div>
  @if (footer === 'UNAUTHORIZED') {
    <footer id="footer" class="simple">
      <div class="inner">
        <p class="copyright simple" [innerHTML]="'FOOTER.COPY_RIGHT_SMALL' | t">
          Copyright © UMMA and Craver Corporation. All Rights Reserved 2019
        </p>
        <a [routerLink]="['/policy']" target="_blank" [innerHTML]="'FOOTER.SERVICE_TERMS' | t">Terms of service</a>
        <a href="/policy?type=PRIVACY" target="_blank" [innerHTML]="'FOOTER.PRIVACY_POLICY' | t">Privacy Policy</a>
      </div>
    </footer>
  }
  @if (footer === 'AUTHORIZED') {
    <footer id="footer">
      <div class="inner">
        <app-go-to-top></app-go-to-top>
        <app-add-to-cart></app-add-to-cart>
        <div class="footer-link">
          <ul>
            <li>
              <a (click)="goMainUrl('our-story')" [innerHTML]="'FOOTER.ABOUT' | t" class="underline-action white"
                >About us</a
              >
            </li>
            <li>
              <a
                [routerLink]="['/policy']"
                target="_blank"
                [innerHTML]="'FOOTER.SERVICE_TERMS' | t"
                class="underline-action white"
                >Terms of service</a
              >
            </li>
            <li>
              <a
                href="/policy?type=PRIVACY"
                target="_blank"
                [innerHTML]="'FOOTER.PRIVACY_POLICY' | t"
                class="underline-action white"
                >Privacy Policy</a
              >
            </li>
            <li>
              <a href="/my/faq" class="underline-action white">FAQ</a>
            </li>
            <!-- <li>
                        <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
                        <a
                          href="https://api.whatsapp.com/send?phone=821030570534"
                          class="underline-action white"
                          target="_blank"
                          rel="nofollow"
                          >
                          CS Manager (All Inquiries)
                        </a>
                      </li> -->
            <!-- <li>
                      <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
                      <a href="https://api.whatsapp.com/send?phone=821066930534" class="underline-action white" target="_blank"
                        rel="nofollow">
                        Asia (IN, MY, EN)
                      </a>
                    </li>
                    <li>
                      <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
                      <a href="https://api.whatsapp.com/send?phone=821066950534" class="underline-action white" target="_blank"
                        rel="nofollow">
                        CIS (RU, EN)
                      </a>
                    </li> -->
            <!-- <li>
                    <a href="javascript:void(0);" style="cursor: default;">10:00 ~ 19:00 KST, Mon ~ Fri</a>
                  </li> -->
            <!-- <li>
                  <dl>
                    <dt class="underline-action white">
                      <a href="https://api.whatsapp.com/send?phone=821024610534" class="info-block" target="_blank"
                        rel="nofollow">
                        <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
                        <span>+82-10-2461-0534 America & Europe (English, Korean)</span>
                      </a>
                    </dt>
                    <dt class="underline-action white">
                      <a href="https://api.whatsapp.com/send?phone=821066930534" class="info-block" target="_blank"
                        rel="nofollow">
                        <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
                        <span>+82-10-6693-0534 Asia (Indonesian, Malaysian, English)</span>
                      </a>
                    </dt>
                    <dt class="underline-action white">
                      <a href="https://api.whatsapp.com/send?phone=821066950534" class="info-block" target="_blank"
                        rel="nofollow">
                        <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
                        <span>+82-10-6695-0534 CIS (Russian, English)</span>
                      </a>
                    </dt>
                    <dd style="margin: 5px 0 0 28px;">10:00 ~ 19:00 KST, Mon ~ Fri</dd>
                  </dl>
                </li> -->
          </ul>
        </div>
        <div class="footer-info">
          <p class="logo">
            <img src="/assets/images/pc/logo_umma_footer.svg" alt="umma" />
          </p>
          <ul class="information">
            <li>CEO : Hangil Chun</li>
            <li><span [innerHTML]="'FOOTER.BUSINESS_NUMBER' | t">Business Number</span> : 261-81-14845</li>
            <li>
              <span [innerHTML]="'FOOTER.CONTACT' | t">Contact</span> :
              <a class="underline-action white" href="mailto:cs@umma.io">cs&#64;umma.io</a>
            </li>
          </ul>
          <p class="address" [innerHTML]="'FOOTER.ADDRESS' | t">
            Seoul Office : 4th Floor, 152 Teheran-ro, Gangnam-gu, Seoul, Republic of Korea (06236)
          </p>
          <p class="address">Korea Warehouse : {{ WAREHOUSE.KR.address }}</p>
          <p class="address">Europe Warehouse : {{ WAREHOUSE.EU.address }}</p>
          <p class="address last">America Warehouse : {{ WAREHOUSE.US.address }}</p>
          <div class="pay">
            <p [innerHTML]="'FOOTER.PAYMENT' | t">Payment Method</p>
            <span [innerHTML]="'FOOTER.PAYMENT_2' | t">We accept following payment methods online.</span>
            <ul>
              <li><img src="/assets/images/pc/icon-tt.png" alt="tt" /></li>
              <li><img src="/assets/images/pc/icon-visa.png" alt="visa" /></li>
              <li><img src="/assets/images/pc/icon-master.png" alt="master" /></li>
              <li><img src="/assets/images/pc/icon-american.png" alt="americanex" /></li>
              <li><img src="/assets/images/pc/icon-paypal.png" alt="paypal" /></li>
              <li><img src="/assets/images/pc/icon-payoneer.png" alt="payon" /></li>
            </ul>
          </div>
        </div>
        <div class="footer-bottom">
          <p class="copyright" [innerHTML]="'FOOTER.COPY_RIGHT_SMALL' | t">
            Copyright © UMMA and Craver Corporation. All Rights Reserved 2019
          </p>
          <dl>
            <dt>SNS</dt>
            <dd class="sns">
              <ul>
                <li>
                  <a class="underline-action white" style="color: #ffffff" (click)="goMainUrl('umma-beauty')"
                    >UMMA blog</a
                  >
                </li>
                <li>
                  @if (lang.locale === LANGUAGE_TYPE.EN) {
                    <a href="https://www.facebook.com/UMMA-global-104619111257386" target="_blank"
                      ><img src="/assets/images/ico_facebook.svg" alt="facebook"
                    /></a>
                  }
                  @if (lang.locale === LANGUAGE_TYPE.VI) {
                    <a href="https://www.facebook.com/ummavn" target="_blank"
                      ><img src="/assets/images/ico_facebook.svg" alt="facebook"
                    /></a>
                  }
                </li>
                <li>
                  @if (lang.locale === LANGUAGE_TYPE.EN) {
                    <a href="https://www.instagram.com/umma_wholesale/" target="_blank"
                      ><img src="/assets/images/ico_instargram.svg" alt="instargram"
                    /></a>
                  }
                  @if (lang.locale === LANGUAGE_TYPE.VI) {
                    <a href="https://www.instagram.com/umma_wholesale/" target="_blank"
                      ><img src="/assets/images/ico_instargram.svg" alt="instargram"
                    /></a>
                  }
                </li>
                <li>
                  @if (lang.locale === LANGUAGE_TYPE.EN) {
                    <a href="https://www.tiktok.com/@umma.wholesale" target="_blank"
                      ><img src="/assets/images/icon-social-tictok.svg" alt="tictok"
                    /></a>
                  }
                  @if (lang.locale === LANGUAGE_TYPE.VI) {
                    <a href="https://www.tiktok.com/@umma.wholesale" target="_blank"
                      ><img src="/assets/images/icon-social-tictok.svg" alt="tictok"
                    /></a>
                  }
                </li>
              </ul>
            </dd>
          </dl>
        </div>
      </div>
    </footer>
  }
</div>

<app-inquiry-pc [type]="INQUIRY_TYPE.PRODUCT" #inquiry [isRequestProduct]="true"></app-inquiry-pc>
